if (!customElements.get('header-bar')) {
  const COOKIE = 'header-bar-state';
  const HIDE_MS = 24 * 60 * 60 * 1000;
  const MAX_CLOSES = 2;
  const MAX_ENTRIES = 10;

  // Functional (C0003) consent from OneTrust. If OneTrust hasn't loaded, treat as no consent.
  const hasFunctionalConsent = () => {
    const groups = window.OnetrustActiveGroups;
    return typeof groups === 'string' && groups.indexOf(',C0003,') !== -1;
  };

  const clearState = () => {
    document.cookie = COOKIE + '=; Max-Age=0; path=/';
  };

  const readState = () => {
    try {
      const raw = typeof getCookie === 'function' ? getCookie(COOKIE) : null;
      return raw ? JSON.parse(decodeURIComponent(raw)) : {};
    } catch (e) {
      return {};
    }
  };

  const writeState = (state) => {
    if (!hasFunctionalConsent()) return;
    try {
      const ids = Object.keys(state);
      if (ids.length > MAX_ENTRIES) {
        ids
          .sort((a, b) => state[a].h - state[b].h)
          .slice(0, ids.length - MAX_ENTRIES)
          .forEach((id) => delete state[id]);
      }
      if (typeof setCookie === 'function') {
        setCookie(COOKIE, encodeURIComponent(JSON.stringify(state)), 365);
      }
    } catch (e) {}
  };

  // Remove the cookie if Functional consent is withdrawn
  window.addEventListener('OneTrustGroupsUpdated', () => {
    if (!hasFunctionalConsent()) clearState();
  });

  class HeaderBar extends HTMLElement {
    connectedCallback() {
      this.barId = this.getAttribute('data-bar-id') || 'default';

      const entry = readState()[this.barId];
      if (entry && (entry.c >= MAX_CLOSES || Date.now() < entry.h)) {
        this.classList.add('hidden');
      }

      this.closeBtn = this.querySelector('[header-bar="close"]');
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.onClose());
      }
    }

    onClose() {
      this.classList.add('hidden');
      const state = readState();
      const count = ((state[this.barId] && state[this.barId].c) || 0) + 1;
      state[this.barId] = { c: count, h: Date.now() + HIDE_MS };
      writeState(state);
    }
  }
  customElements.define('header-bar', HeaderBar);
}